import { Panel } from '@epam/promo';
import { BroadcastHeader } from '../BroadcastHeader';
import { FormBody } from '../form-body';
import css from './BroadcastForm.module.scss';

export const BroadcastForm = () => (
  <Panel shadow cx={css.page__container}>
    <BroadcastHeader />
    <FormBody />
  </Panel>
);
